module.exports = __webpack_public_path__ + "media/images/dummys/white-e080e1aca27ef11e460a609d08ba50f2.jpg";